// removed by extract-text-webpack-plugin
module.exports = {"doorbell-container":"DoorbellButton__doorbell-container___2u_mK","tooltip":"DoorbellButton__tooltip___3o5Hu"};